import { X } from 'lucide';

export const WARNING_TITLE_ID = 'supplied-listing-link-warning-title';
export const WARNING_DESCRIPTION_ID = 'supplied-listing-link-warning-description';
const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

function buildIconNode([tag, attributes = {}, children = []]) {
  const element = document.createElementNS(SVG_NAMESPACE, tag);
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
  children.forEach((child) => element.append(buildIconNode(child)));

  return element;
}

function buildCloseButton() {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = [
    'sm-button',
    'sm-button--ghost',
    'sm-button--icon-only',
    'sm-modal-header__close',
    'js-modal-close-trigger',
  ].join(' ');
  button.setAttribute('aria-label', 'Close');

  const iconSlot = document.createElement('span');
  iconSlot.className = 'sm-button__icon';
  iconSlot.setAttribute('aria-hidden', 'true');

  const icon = buildIconNode(X);
  icon.setAttribute('width', '20');
  icon.setAttribute('height', '20');
  icon.setAttribute('stroke-width', '1.5');
  iconSlot.append(icon);
  button.append(iconSlot);

  return button;
}

function addBreakableText(element, value) {
  value.split(/([.@])/).forEach((part) => {
    element.append(document.createTextNode(part));
    if (part === '.' || part === '@') element.append(document.createElement('wbr'));
  });
}

export function buildSuppliedListingLinkWarningContent({destination, href, opensNewContext}) {
  const content = document.createElement('div');
  content.className = [
    'supplied-listing-link-warning',
    'sm-modal',
    'js-supplied-listing-link-warning',
  ].join(' ');

  const header = document.createElement('div');
  header.className = 'sm-modal-header';

  const title = document.createElement('h2');
  title.id = WARNING_TITLE_ID;
  title.className = 'sm-modal-header__title';
  title.textContent = 'Open this link?';
  header.append(title, buildCloseButton());

  const body = document.createElement('div');
  body.className = 'supplied-listing-link-warning__body sm-stack sm-stack--l';

  const introduction = document.createElement('div');
  introduction.className = 'sm-typestyle sm-typestyle--body-default';
  introduction.textContent = 'You\'re about to open a link to:';

  const destinationText = document.createElement('div');
  destinationText.className = [
    'supplied-listing-link-warning__destination',
    'sm-typestyle',
    'sm-typestyle--body-strong',
    'js-supplied-listing-link-destination',
  ].join(' ');
  addBreakableText(destinationText, destination);

  const description = document.createElement('div');
  description.id = WARNING_DESCRIPTION_ID;
  description.className = 'sm-typestyle sm-typestyle--body-default';
  description.textContent = 'Check the destination before continuing.';

  const actions = document.createElement('div');
  actions.className = 'supplied-listing-link-warning__actions sm-cluster sm-cluster--m sm-cluster--actions';

  const cancel = document.createElement('button');
  cancel.type = 'button';
  cancel.className = 'sm-button sm-button--neutral js-modal-close-trigger js-supplied-listing-link-cancel';
  cancel.textContent = 'Cancel';

  const continueLink = document.createElement('a');
  continueLink.className = 'sm-button sm-button--primary js-supplied-listing-link-continue';
  continueLink.href = href;
  continueLink.rel = 'nofollow noopener noreferrer ugc';
  continueLink.textContent = 'Continue';
  if (opensNewContext) continueLink.target = '_blank';

  actions.append(cancel, continueLink);
  body.append(introduction, destinationText, description, actions);
  content.append(header, body);

  return content.outerHTML;
}
